import { createSelector } from 'reselect';

import { initialState } from './reducers';

const selectState = (state: any) => state.get('locationsPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
